var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllusUpgradeError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M64 128C99.3462 128 128 99.3462 128 64C128 28.6538 99.3462 0 64 0C28.6538 0 0 28.6538 0 64C0 99.3462 28.6538 128 64 128Z",
    fill: "url(#paint0_linear_1248_81530)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3903 51.8689C48.0467 51.8689 53.4427 46.5257 53.4427 39.9345C53.4427 33.3432 48.0467 28 41.3903 28C34.734 28 29.3379 33.3432 29.3379 39.9345C29.3379 46.5257 34.734 51.8689 41.3903 51.8689ZM98.6627 39.9345C98.6627 46.5257 93.2666 51.8689 86.6103 51.8689C79.9539 51.8689 74.5579 46.5257 74.5579 39.9345C74.5579 33.3432 79.9539 28 86.6103 28C93.2666 28 98.6627 33.3432 98.6627 39.9345ZM86.6141 81.4601C90.4443 81.4601 97.3269 81.4601 101.452 80.9816C105.419 80.5226 108.892 76.7065 107.293 69.8407C104.253 56.817 95.6102 54.8059 86.6141 54.7631C77.6141 54.8059 68.9755 56.817 65.9349 69.8407C64.3361 76.7104 67.8088 80.5226 71.7765 80.9816C75.9013 81.4601 82.7839 81.4601 86.6141 81.4601ZM41.3862 81.4601C37.556 81.4601 30.6734 81.4601 26.5485 80.9816C22.5808 80.5226 19.1081 76.7065 20.707 69.8407C23.7476 56.817 32.3901 54.8059 41.3862 54.7631C50.3862 54.8059 59.0247 56.817 62.0653 69.8407C63.6642 76.7104 60.1915 80.5226 56.2238 80.9816C52.0989 81.4601 45.2164 81.4601 41.3862 81.4601Z",
    fill: "url(#paint1_linear_1248_81530)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3862 62.4968C42.2865 62.4968 43.0164 61.774 43.0164 60.8824C43.0164 59.9908 42.2865 59.2681 41.3862 59.2681C40.4858 59.2681 39.7559 59.9908 39.7559 60.8824C39.7559 61.774 40.4858 62.4968 41.3862 62.4968ZM41.3862 69.0826C42.2865 69.0826 43.0164 68.3599 43.0164 67.4683C43.0164 66.5767 42.2865 65.854 41.3862 65.854C40.4858 65.854 39.7559 66.5767 39.7559 67.4683C39.7559 68.3599 40.4858 69.0826 41.3862 69.0826ZM86.6102 62.4968C87.5105 62.4968 88.2404 61.774 88.2404 60.8824C88.2404 59.9908 87.5105 59.2681 86.6102 59.2681C85.7098 59.2681 84.9799 59.9908 84.9799 60.8824C84.9799 61.774 85.7098 62.4968 86.6102 62.4968ZM86.6102 69.0826C87.5105 69.0826 88.2404 68.3599 88.2404 67.4683C88.2404 66.5767 87.5105 65.854 86.6102 65.854C85.7098 65.854 84.9799 66.5767 84.9799 67.4683C84.9799 68.3599 85.7098 69.0826 86.6102 69.0826Z",
    fill: "#E3E9FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.003 49.3795C79.003 57.5863 72.2843 64.2393 63.9964 64.2393C55.7085 64.2393 48.9898 57.5863 48.9898 49.3795C48.9898 41.1727 55.7085 34.5198 63.9964 34.5198C72.2843 34.5198 79.003 41.1727 79.003 49.3795ZM64.0003 100C68.7694 100 77.3412 100 82.4756 99.4048C87.4137 98.8369 91.7389 94.0872 89.7471 85.537C85.9601 69.3196 75.2041 66.8145 64.0003 66.7639C52.7964 66.8145 42.0404 69.3196 38.2534 85.537C36.2617 94.0872 40.5869 98.833 45.5249 99.4048C50.6633 100 59.2312 100 64.0003 100Z",
    fill: "url(#paint2_linear_1248_81530)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.3771 75.7966C66.3771 77.0963 65.313 78.15 64.0004 78.15C62.6878 78.15 61.6237 77.0963 61.6237 75.7966C61.6237 74.4968 62.6878 73.4431 64.0004 73.4431C65.313 73.4431 66.3771 74.4968 66.3771 75.7966ZM66.3771 85.3854C66.3771 86.6852 65.313 87.7389 64.0004 87.7389C62.6878 87.7389 61.6237 86.6852 61.6237 85.3854C61.6237 84.0857 62.6878 83.032 64.0004 83.032C65.313 83.032 66.3771 84.0857 66.3771 85.3854Z",
    fill: "#E3E9FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8522 111.769C82.441 111.769 76.4086 105.737 76.4086 98.3257C76.4086 90.9145 82.441 84.8821 89.8522 84.8821C97.2633 84.8821 103.296 90.9145 103.296 98.3257C103.296 105.737 97.2633 111.769 89.8522 111.769Z",
    fill: "url(#paint3_linear_1248_81530)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.7099 100.227C88.7387 100.834 89.2406 101.315 89.852 101.315C90.4576 101.315 90.9594 100.834 90.994 100.227L91.4266 91.9924C91.4728 91.0839 90.7575 90.3258 89.852 90.3258C88.9464 90.3258 88.2311 91.0896 88.2773 91.9924L88.7099 100.227ZM91.5134 104.659C91.5134 105.58 90.7696 106.326 89.8522 106.326C88.9347 106.326 88.191 105.58 88.191 104.659C88.191 103.739 88.9347 102.993 89.8522 102.993C90.7696 102.993 91.5134 103.739 91.5134 104.659Z",
    fill: "#7C5A33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.6455 98.3257C77.6455 105.048 83.1204 110.528 89.8522 110.528C96.5839 110.528 102.059 105.048 102.059 98.3257C102.059 91.6037 96.5839 86.123 89.8522 86.123C83.1204 86.123 77.6455 91.6037 77.6455 98.3257ZM76.4086 98.3257C76.4086 105.737 82.441 111.769 89.8522 111.769C97.2633 111.769 103.296 105.737 103.296 98.3257C103.296 90.9145 97.2633 84.8821 89.8522 84.8821C82.441 84.8821 76.4086 90.9145 76.4086 98.3257Z",
    fill: "white",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1248_81530",
    x1: 42.9061,
    y1: 146.641,
    x2: 79.1937,
    y2: 18.1881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3591E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1248_81530",
    x1: 63.9977,
    y1: 81.4571,
    x2: 63.9977,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#548AFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A3C9FF",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1248_81530",
    x1: 58.2096,
    y1: 19.3644,
    x2: 59.6434,
    y2: 112.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3EDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469602,
    stopColor: "#5689FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.493161,
    stopColor: "#A6C2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#165DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1248_81530",
    x1: 82.306,
    y1: 111.769,
    x2: 95.524,
    y2: 86.8465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDAD0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD600"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllusUpgradeError);
export default __webpack_public_path__ + "static/media/illus_upgrade_error.d91c793ae8387ff34c769f1ccc1f7133.svg";
export { ForwardRef as ReactComponent };